export default {
    //Package module constants
    ScreenProductTypeName: "Screens",
    VODProductTypeName: "Video on Demand",
    channelProductTypeName: "channel",
    ChannelBundleProductTypeName: "Channel Bundle"
}
